import { createRouterSelector } from '@atlassian/react-resource-router/src/controllers/router-store';
import { fg } from '@atlassian/jira-feature-gating';
import type { RouteName } from '@atlassian/jira-route-name-types/src/RouteName.tsx';
import type { RouteGroup } from '@atlassian/jira-route-name-types/src/RouteGroup.tsx';

/*
 * Controls whether specific routes can see the Rovo button.
 * Consult with the team in #global-rovo-button-roll-out in Slack if you have any questions.
 *
 * Add your routes here to control it using an experiment, feature gate, or static false value
 * Returning true will enable the Rovo button for the route if the global_rovo_button_in_jira feature gate is also enabled
 * Returning false will disable the Rovo button for the route
 */
const blacklistedJiraRoutes: Partial<Record<RouteName, () => boolean>> = {};

/*
 * Controls whether specific route groups can see the Rovo button.
 * Consult with the team in #global-rovo-button-roll-out in Slack if you have any questions.
 *
 * Add your routes groups here to control it using an experiment, feature gate, or static false value
 * Returning true will enable the Rovo button for the route group if the global_rovo_button_in_jira feature gate is also enabled
 * Returning false will disable the Rovo button for the route group
 */
const blacklistedJiraRouteGroups: Partial<Record<RouteGroup, () => boolean>> = {
	polaris: () => false, // JPD
	servicedesk: () => false, // JSM
};

export const useIsRovoAvailableForRoute = createRouterSelector((state) => {
	const routeName = state.route.name;
	const routeGroup = state.route.group;

	// all routes blocked until global_rovo_button_in_jira is turned on
	if (fg('global_rovo_button_in_jira')) {
		// Group-level takes precedence
		if (routeGroup && blacklistedJiraRouteGroups[routeGroup]) {
			return blacklistedJiraRouteGroups[routeGroup]() ?? false;
		}

		// Exclude embedded routes
		if (routeName.endsWith('-embed')) {
			return false;
		}

		if (blacklistedJiraRoutes[routeName]) {
			return blacklistedJiraRoutes[routeName]() ?? false;
		}

		return true;
	}

	return false;
});
